import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRoutePoint } from "../slices/alcoholSlice";
import { updateLatLong } from "../slices/locationSlice";

export default function useRefreshLocation() {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  useEffect(() => {
    const refreshLocation = () => {
      if (!user.behavior.locationSharing) {
        return dispatch(updateLatLong({ latitude: null, longitude: null }));
      }
      if (Capacitor.isNativePlatform()) {
        Geolocation.getCurrentPosition({ enableHighAccuracy: true })
          .then((position) => {
            const { latitude, longitude } = position.coords;
            dispatch(updateLatLong({ latitude, longitude }));
            dispatch(addRoutePoint({ latitude, longitude }));
          })
          .catch(() => {});
      } else {
        navigator?.geolocation?.getCurrentPosition?.((position) => {
          const { latitude, longitude } = position.coords;
          dispatch(updateLatLong({ latitude, longitude }));
          dispatch(addRoutePoint({ latitude, longitude }));
        });
      }
    };

    refreshLocation();
    const interval = setInterval(() => {
      refreshLocation();
    }, 15000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.behavior.locationSharing]);
}
